import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';

import { ModalModule } from 'ngx-bootstrap/modal';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';

import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthService } from './features/auth/services/auth.service';
import { ProfileService } from './features/user/profile/services/profile.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([JwtInterceptor])),
    provideAnimations(), // required animations providers
    provideToastr({
      timeOut: 5000, // 0
      //extendedTimeOut: 0,
      closeButton: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    BrowserAnimationsModule,
    BrowserModule,
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    importProvidersFrom(
      ModalModule.forRoot(),
      NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
    ),
    AuthService,
    ProfileService,
  ],
};
